module.exports = __webpack_public_path__ + "img/Logo_el_Padronet_celebracio.56d14e40.png";